import React, { useState, useEffect } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
import { SlotGames } from "../../lib/data/SlotGames.data";
import { casinoTabs } from "../../lib/data";
import { casinoGamesList } from "../../lib/data/casinoGames.data";
import { altGaming } from "../../lib/data/altGaming.data";
import { KingmakerGames } from "../../lib/data/KingmakerGames.data";
import { VenumGames } from "../../lib/data/VenumGames.data";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);
  const totalGames = [
    ...Object.values(casinoTabs?.venumgames),
    ...Object.values(casinoGamesList?.XPG),
    ...Object.values(casinoGamesList?.andarbahar),
    ...Object.values(casinoGamesList?.baccarat),
    ...Object.values(casinoGamesList?.blackjack),
    ...Object.values(casinoGamesList?.improvedExperience),
    ...Object.values(casinoGamesList?.kingmaker),
    ...Object.values(casinoGamesList?.livecasino),
    ...Object.values(casinoGamesList?.roulette),
    ...Object.values(casinoGamesList?.spribe),
    ...Object.values(casinoGamesList?.supernowa),
    ...Object.values(casinoGamesList?.worldcasino),
    ...Object.values(altGaming?.jiliGaming),
    ...Object.values(altGaming?.mac88Gaming),
  ];

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };

  const handleSearch = (value) => {
    if (!value) {
      setFilteredData(null);
      return;
    }
    let games = [];
    totalGames.forEach((game) => games.push(game));
    const filteredValue = games.filter((game) =>
      game?.name?.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredData(filteredValue);
  };

  return (
    <>
      <div className="search-box">
        <div className="searchGames" onClick={handleShow}>
          <BiSearch />
          <p>Search...</p>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} className="search-modal">
        <Modal.Header closeButton closeVariant="black">
          <Modal.Title>Search Games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search your favourite games here..."
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>

          <ul className="game-list">
            {filteredData &&
              filteredData.map((item, idx) => (
                <li key={idx}>
                  <a href={item.redirectUrl || item.href}>
                    <img src={item.imgUrl} alt={item?.alt || "gameName"} />
                    {/* <span>{item.name}</span> */}
                  </a>
                </li>
              ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
